<script>
import { MixPanel } from '@/mixin/mixpanel'
import ModalConfig from './ModalConfig.vue'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name: 'GridOptions',
  components: {
    Multiselect,
    ModalConfig,
  },
  mixins: [MixPanel, Helper],
  props: {
    isMobileView: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const isNewView = JSON.parse(localStorage.getItem('live-streaming-switch-view-on')) ?? true
    return {
      fullscreen: false,
      isNewView: isNewView,
      gridOptions: [
        { text: 'Grid 1', value: 1 },
        { text: 'Grid 4', value: 4 },
        { text: 'Grid 6', value: 6 },
        { text: 'Grid 8', value: 8 },
        { text: 'Grid 9', value: 9 },
        { text: 'Grid 16', value: 16 },
        { text: 'Grid 25', value: 25 },
      ],
      gridModel: { text: 'Grid 9', value: 9 },
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
  },
  watch: {
    async isNewView(val) {
      localStorage.setItem('live-streaming-switch-view-on', JSON.stringify(val))
      this.delay(250)
      window.location.reload()
    },
    isMobileView(val) {
      if (val) {
        this.gridModel = { text: 'Grid 25', value: 25 }
      }
    },
  },
  mounted() {
    window.addEventListener('popstate', (event) => {
      if (document.body.classList.contains('mc-trackvideo-fullscreen')) {
        document.body.classList.remove('mc-trackvideo-fullscreen')
      }
    })
  },
  methods: {
    async clickFullScreen() {
      this.fullscreen = !this.fullscreen
      await this.$nextTick()

      this.track('Video Streaming Full Screen')

      document.body.classList.toggle('mc-trackvideo-fullscreen')
    },
    showModalSetting() {
      this.$bvModal.show('trackvideo-setting')
    },
    onInput(value) {
      this.$emit('clickGridNumber', value.value)
    },
    openModalSelectVehicleBroadcast() {
      this.track('Open Live Broadcast')
      this.$bvModal.show('trackvision-broadcast-modal')
    },
  },
}
</script>

<template>
  <div class="mc-trackvideo-content__view">
    <span
      v-if="hasAccess(['b3n-trackvision-toggle-video-status:read'])"
      v-show="!isMobileView"
      class="form-switch form-switch-md me-trackvision__switch-new-view-wrapper me-trackvision__switch-from-header"
      @click="isNewView = !isNewView"
    >
      {{ $t('global.newView') }}
      <input v-model="isNewView" class="form-check-input" type="checkbox" />
    </span>
    <div
      v-show="hasAccess(['b3n-trackvision-toggle-video-status:read']) && !isMobileView"
      class="mc-trackvideo-content__view-divider"
    ></div>
    <b-button
      v-if="hasAccess(['b3p-trackvision-multivoip:read'])"
      size="sm"
      variant="outline-primary"
      class="mc-trackvision__btn-live-broadcast"
      :disabled="$store.state.voip.isTwoWayActive"
      @click="openModalSelectVehicleBroadcast"
    >
      <i class="mc-fa icon-fill_volume-up" />
      {{ 'Live Broadcast' }}
    </b-button>
    <div
      v-show="hasAccess(['b3p-trackvision-multivoip:read']) && !isMobileView"
      class="mc-trackvideo-content__view-divider"
    ></div>
    <Multiselect
      v-if="!isMobileView"
      v-model="gridModel"
      :options="gridOptions"
      :searchable="false"
      :close-on-select="false"
      :clear-on-select="false"
      :allow-empty="false"
      track-by="value"
      label="text"
      @input="onInput"
    />
    <span class="mc-trackvideo-content__view-button fullscreen" @click="clickFullScreen()">
      <i class="mc-fa icon-fill_fullscreen"></i>
      <i class="mc-fa icon-fill_exit-fullscreen"></i>
    </span>
    <div class="mc-trackvideo-content__view-divider"></div>
    <span class="mc-trackvideo-content__view-button" @click="showModalSetting()">
      <i class="mc-fa icon-outline_settings"></i>
    </span>
    <ModalConfig :isMobileView="$props.isMobileView" />
  </div>
</template>
<style lang="scss">
.mc-trackvideo-content__view {
  display: flex;
  align-items: center;
  column-gap: 8px;
}
.mc-trackvideo-content__view-button {
  margin-right: 0;
  height: 21px;
  width: 21px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.me-trackvision__switch-new-view-wrapper {
  display: inline-block;
  font-size: 12px;
  height: 22px;
  margin-bottom: 0 !important;
  background-color: $cyan-100;
  padding: 18px 16px;
  display: flex;
  align-items: center;
  column-gap: 4px;
  border-radius: 20px;
  position: relative;
  input {
    margin-left: 0 !important;
    position: static !important;
    margin-top: 0 !important;
  }
}

.mc-trackvideo-content__view-button.grid-1 {
  margin-left: 8px;
}

.mc-trackvision__btn-live-broadcast {
  display: flex;
  align-items: center;
  column-gap: 4px;
}
</style>
